export const printStrings: Record<string, [string, string, string]> = {
  'phone.keyboard': ['輸入手機號碼', 'Enter mobile number', '携帯電話番号の入力'],
  'phone.label': ['手機號碼（必填）', 'Mobile number (required)', '携帯電話番号（必須）'],
  'phone.hint': [
    '請選擇國碼，並輸入購票時填寫的完整手機號碼，以查詢補印。',
    'Select the country code and enter the full purchase mobile number to find tickets for reprinting.',
    '国番号を選び、購入時の携帯電話番号をすべて入力して再印刷する注文を検索してください。',
  ],
  'phone.invalid': [
    '請確認國碼與完整手機號碼是否正確。',
    'Check the country code and full mobile number.',
    '国番号と携帯電話番号を確認してください。',
  ],
  'reprint.keyboard': ['訂單編號鍵盤', 'Order number keyboard', '注文番号キーボード'],
  'phone.retained': [
    '重新付款沿用原訂單的聯絡手機。',
    'Payment retry keeps the original contact number.',
    '再決済では元の注文の連絡先を使用します。',
  ],
  'reprint.byPhone': ['手機號碼查詢', 'Find by mobile', '携帯番号で検索'],
  'reprint.byOrder': ['訂單編號查詢', 'Find by order number', '注文番号で検索'],
  'reprint.selectOrder': [
    '請選擇要補印的訂單',
    'Choose an order to reprint',
    '再印刷する注文を選んでください',
  ],
  'reprint.select': ['選擇此訂單', 'Select this order', 'この注文を選択'],
  'reprint.more': ['載入更多訂單', 'Load more orders', '注文をさらに表示'],
  'reprint.phoneNotFound': [
    '此頁查無可補印訂單。若有更多訂單請繼續載入；舊訂單未留手機時，請改用訂單編號或洽櫃檯。',
    'No eligible orders on this page. Load more if available. Older orders without a mobile can be found by order number; otherwise ask staff.',
    'このページに再印刷可能な注文はありません。続きがあれば読み込んでください。電話番号未登録の注文は注文番号で検索するか係員にお尋ねください。',
  ],
  'reprint.previousSubmitted': [
    '此訂單上次補印資料已送出。請確認出紙口並取走票券；若未收到或仍需協助，請洽櫃檯。',
    'The previous reprint was sent. Check the outlet and collect your tickets. If you did not receive them or need help, please ask staff.',
    '前回の再印刷データは送信済みです。排紙口でチケットをお取りください。受け取れない場合やお困りの場合は係員にお尋ねください。',
  ],
  'reprint.title': ['補印票券', 'Reprint tickets', 'チケット再印刷'],
  'reprint.description': [
    '輸入購票手機或訂單編號，補印仍有效、尚未核銷的登船票券。已使用、作廢或退款處理中的票券不提供補印。',
    'Find by mobile or order number to reprint valid, unused boarding tickets. Used, voided and refund-related tickets cannot be reprinted.',
    '購入時の携帯番号または注文番号で、有効・未使用の乗船券を再印刷できます。使用済み・無効・払い戻し中の券は対象外です。',
  ],
  'reprint.orderNumber': ['訂單編號', 'Order number', '注文番号'],
  'reprint.orderNumberRequired': [
    '訂單編號（必填）',
    'Order number (required)',
    '注文番号（必須）',
  ],
  'reprint.inputHint': [
    '只需輸入 8 碼訂單日期及最後 8 碼編號，ORD 與連字號會自動補上。也可直接貼上完整訂單編號。',
    'Enter the 8-digit order date and final 8 characters. ORD and hyphens are automatic. You can also paste the full order number.',
    '注文日の数字8桁と末尾8文字を入力してください。ORD とハイフンは自動で付きます。注文番号全体の貼り付けも可能です。',
  ],
  'reprint.delete': ['刪除', 'Delete', '削除'],
  'reprint.clearAll': ['全部清除', 'Clear all', 'すべてクリア'],
  'reprint.lookup': ['查詢訂單', 'Find order', '注文を検索'],
  'reprint.searching': ['正在查詢訂單…', 'Finding your order…', '注文を検索しています…'],
  'reprint.count': [
    '可補印 {count} 張票券',
    '{count} tickets available to reprint',
    '再印刷可能：{count} 枚',
  ],
  'reprint.itemCount': [
    '原購 {total} 張，可補印 {count} 張',
    '{total} purchased, {count} available',
    '購入 {total} 枚・再印刷可能 {count} 枚',
  ],
  'reprint.excluded': [
    '此訂單共 {total} 張票，已核銷 {used} 張，其他不可補印 {unavailable} 張。',
    'Order total: {total}. Used: {used}. Other unavailable tickets: {unavailable}.',
    '合計 {total} 枚、使用済み {used} 枚、その他対象外 {unavailable} 枚。',
  ],
  'reprint.allUsed': [
    '此訂單票券皆已使用，無可補印票券。',
    'All tickets have been used. No tickets are available to reprint.',
    'すべて使用済みのため再印刷できません。',
  ],
  'reprint.noneEligible': [
    '此訂單目前沒有符合資格的可補印票券。',
    'No tickets in this order are currently eligible for reprinting.',
    '現在、再印刷可能な券はありません。',
  ],
  'reprint.refresh': ['重新查詢此訂單', 'Refresh this order', 'この注文を再検索'],
  'reprint.changed': [
    '票券狀態或列印內容已變更，請重新查詢後確認可補印數量。若已有出紙或列印結果未確認，請先確認出紙口並洽櫃檯。',
    'Ticket eligibility or print content changed. Refresh the order to check the available count. If any pages printed or the result is uncertain, check the outlet and ask staff.',
    '券の状態または印刷内容が変更されました。注文を再検索してください。印刷済み・結果不明の場合は排紙口を確認し、係員にお尋ねください。',
  ],
  'reprint.sameTickets': [
    '補印保留原票號與 QR Code，不會再次收費，也不增加可搭乘次數。只補印登船票券，不含發票與交易明細。請先確認出紙口，避免重複取票。',
    'Reprints use the original ticket numbers and QR codes. No new charge or additional rides. Boarding tickets only; invoices and receipts are excluded. Check the paper outlet first.',
    '元の券番号と QR コードを使用します。追加料金や乗船回数の追加はありません。請求書・明細は含まれません。先に排紙口をご確認ください。',
  ],
  'reprint.confirm': ['確認補印 {count} 張票券', 'Reprint {count} tickets', '{count} 枚を再印刷'],
  'reprint.submitted': [
    '補印資料已送出，請確認出紙口並取走所有票券。若未收到票券，請洽櫃檯協助。',
    'Reprint data sent. Please check the outlet and collect all tickets. If you did not receive them, please ask staff.',
    '再印刷データを送信しました。排紙口ですべてのチケットをお取りください。受け取れない場合は係員にお尋ねください。',
  ],
  'reprint.other': ['查詢其他訂單', 'Find another order', '別の注文を検索'],
  'reprint.notFound': [
    '查無訂單，請確認完整訂單編號。',
    'Order not found. Check the full order number.',
    '注文が見つかりません。注文番号をご確認ください。',
  ],
  'reprint.invalid': [
    '訂單編號格式不正確，請重新輸入。',
    'Invalid order number. Please enter it again.',
    '注文番号の形式が正しくありません。再入力してください。',
  ],
  'reprint.ineligible': [
    '此訂單目前無法自助補印。僅限已付款的 Kiosk 訂單中仍有效、未核銷且無退款處理的票券；請重新查詢或洽櫃檯確認。',
    'Only valid, unused tickets without refunds in paid kiosk orders can be reprinted. Refresh the order or ask staff.',
    '支払済みのキオスク注文で、有効・未使用・払い戻し対象外の券のみ再印刷できます。注文を再検索するか係員にお尋ねください。',
  ],
  'reprint.lookupFailed': [
    '暫時無法查詢訂單，請稍後重試或洽櫃檯。',
    'Unable to look up the order. Try again or ask staff.',
    '注文を検索できません。再試行するか係員にお尋ねください。',
  ],
  'reprint.failed': [
    '補印尚未完成，請確認機台列印服務已就緒後重試，或洽櫃檯。',
    'Reprinting did not finish. Check printer readiness and retry, or ask staff.',
    '再印刷を完了できません。プリンターを確認して再試行するか係員にお尋ねください。',
  ],
  'reprint.unknown': [
    '補印結果尚未確認，可能已有部分出紙。請先確認出紙口，再查詢原列印工作；若仍未確認，請洽櫃檯。',
    'Reprint status is unconfirmed; some pages may have printed. Check the outlet and the original job, or ask staff.',
    '再印刷結果が未確認です。一部が印刷済みの可能性があります。排紙口と元のジョブを確認するか係員にお尋ねください。',
  ],
  'reprint.notSent': [
    '補印工作未送出，請保留訂單編號並洽櫃檯處理。',
    'The reprint was not sent. Keep the order number and ask staff.',
    '再印刷ジョブは未送信です。注文番号を控え、係員にお尋ねください。',
  ],
  'reprint.keepNumber': [
    '請拍照或記下完整訂單編號；需要補印時，可至「查詢票券 → 補印票券」輸入此編號。',
    'Save a photo or note the full order number. Use Ticket services → Reprint tickets if needed.',
    '注文番号を撮影・保存してください。必要な場合はチケット照会 → チケット再印刷で入力できます。',
  ],
  'reprint.failureHint': [
    '列印未完成，請拍下訂單編號。未收到票券可按下方補印。',
    'Printing is incomplete. Save the order number and reprint below if you have not received your tickets.',
    '印刷が完了していません。注文番号を保存し、券が出ていない場合は下のボタンで再印刷してください。',
  ],
  'refundPrint.title': ['退款受理單', 'Refund application receipt', '払い戻し申請受付票'],
  'refundPrint.check': ['確認列印狀態', 'Check printing', '印刷状況を確認'],
  'refundPrint.preparing': [
    '正在準備退款受理單…',
    'Preparing your refund receipt…',
    '受付票を準備しています…',
  ],
  'refundPrint.accepted': [
    '退款申請已受理，無須再次申請。',
    'Your refund application is accepted. No need to apply again.',
    '払い戻し申請は受理済みです。再申請は不要です。',
  ],
  'refundPrint.submitted': [
    '退款受理單已送印，請確認出紙並保留單據。',
    'Receipt sent to the printer. Check the paper outlet and keep the receipt.',
    '受付票をプリンターに送信しました。排紙口を確認し、保管してください。',
  ],
  'refundPrint.disabled': [
    '本機未啟用列印，請記下案件編號。',
    'Printing is disabled. Please note your case number.',
    '印刷は無効です。受付番号をお控えください。',
  ],
  'refundPrint.dataUnavailable': [
    '受理單資料不完整，請記下案件編號並洽工作人員。',
    'Receipt data is unavailable. Note your case number and ask staff.',
    '受付票の情報が不足しています。受付番号を控え、係員にお尋ねください。',
  ],
  'refundPrint.failed': [
    '受理單暫時無法列印，請稍後確認列印狀態。',
    'Receipt printing is unavailable. Check printing again shortly.',
    '受付票を印刷できません。しばらくしてから印刷状況をご確認ください。',
  ],
  'refundPrint.unknown': [
    '受理單列印尚未確認，請先查看出紙口。',
    'Receipt printing is unconfirmed. Please check the paper outlet.',
    '受付票の印刷結果が未確認です。排紙口をご確認ください。',
  ],
  'refundPrint.notSent': [
    '受理單尚未送印，請記下案件編號並洽工作人員。',
    'The receipt was not sent. Note your case number and ask staff.',
    '受付票は送信されていません。受付番号を控え、係員にお尋ねください。',
  ],
  'print.preparing': [
    '正在準備列印，請稍候…',
    'Preparing your documents…',
    '印刷を準備しています…',
  ],
  'print.sending': [
    '票券與單據傳送中，請稍候並留意出紙口。',
    'Sending documents. Please wait by the printer.',
    '印刷データを送信中です。排紙口をご確認ください。',
  ],
  'print.submitted': [
    '列印資料已送出，請確認並取走所有紙張。',
    'Documents sent. Please check and collect all pages.',
    '印刷データを送信しました。すべての用紙をお取りください。',
  ],
  'print.unknown': [
    '列印結果尚未確認，可能已有部分出紙。請先確認出紙口並查詢原列印工作，勿重複購票。',
    'Printing is unconfirmed; some pages may have printed. Check the outlet and the original job. Do not buy again.',
    '一部が印刷された可能性があります。排紙口と元の印刷ジョブをご確認ください。再購入しないでください。',
  ],
  'print.failed': [
    '尚未完成列印，請確認列印服務與機台登入，或洽工作人員。勿重複購票。',
    'Printing could not finish. Check the printer and kiosk sign-in or ask staff. Do not buy again.',
    '印刷を完了できません。係員にお尋ねください。再購入しないでください。',
  ],
  'print.notSent': [
    '此列印工作未開始出紙，可使用「補印票券」或洽工作人員。',
    'This job was not sent. Use Reprint tickets or ask staff.',
    'このジョブは未送信です。チケット再印刷をご利用いただくか係員にお尋ねください。',
  ],
  'print.disabled': [
    '此機台尚未啟用列印，請洽工作人員取票。',
    'Printing is not enabled. Please ask staff for your tickets.',
    '印刷は無効です。係員からチケットをお受け取りください。',
  ],
  'print.invoiceUnavailable': [
    '此發票目前無法由機台列印，請洽工作人員；其他票券仍依取票方式處理。',
    'Official invoices are not available yet. Please ask staff; ticket delivery is separate.',
    '正式な領収書は未対応です。係員にお尋ねください。',
  ],
  'print.invoiceWaiting': [
    '正在等待發票開立，請稍候…',
    'Waiting for your invoice…',
    '請求書の発行を待っています…',
  ],
  'print.invoiceSending': [
    '正在一起傳送發票、明細與票券，請留意出紙口。',
    'Sending your invoice, receipt and tickets together. Please check the printer.',
    '請求書・明細・チケットをまとめて送信中です。排紙口をご確認ください。',
  ],
  'print.invoiceSubmitted': [
    '發票、明細與票券已一起送印，請依序取走。',
    'Invoice, receipt and tickets sent together. Please collect all pages.',
    '請求書・明細・チケットをまとめて送信しました。すべてお受け取りください。',
  ],
  'print.invoiceUnknown': [
    '整筆列印結果尚未確認，請先查看出紙口並洽工作人員，勿重複列印。',
    'Order printing is unconfirmed. Check the outlet and ask staff; do not reprint.',
    '印刷結果が未確認です。排紙口を確認し、係員にお尋ねください。再印刷しないでください。',
  ],
  'print.invoiceFailed': [
    '整筆列印尚未完成，請洽工作人員確認發票與票券狀態。',
    'Order printing could not finish. Ask staff to check the invoice and tickets.',
    '印刷が完了していません。係員に請求書とチケットの状況をご確認ください。',
  ],
  'print.sample': [
    '開發模式：本次發票為測試樣張，非正式發票。',
    'Development mode: the invoice is a sample, not an official invoice.',
    '開発モード：請求書はテスト用で、正式なものではありません。',
  ],
  'print.check': [
    '查詢／繼續原列印工作',
    'Check / continue original job',
    '元の印刷ジョブを確認・続行',
  ],
  'print.unavailable': [
    '列印設備暫時無法使用，請稍候或洽工作人員。',
    'Printer unavailable. Please wait or ask staff.',
    'プリンターを利用できません。係員にお尋ねください。',
  ],
  'print.busy': [
    '列印進行中，請稍候並留意出紙口。',
    'Printing in progress. Please wait and check the paper outlet.',
    '印刷中です。排紙口を確認してお待ちください。',
  ],
  'print.rechecking': [
    '暫時無法確認印表機狀態，正在重新查詢。若已出紙，請勿重複列印。',
    'Printer status is temporarily unconfirmed. Checking again. Do not reprint if paper has already come out.',
    'プリンターの状態を再確認しています。すでに用紙が出ている場合は再印刷しないでください。',
  ],
  'print.checkingJob': [
    '正在查詢原列印工作，請確認出紙並稍候，勿重複操作。',
    'Checking the original print job. Check the paper outlet and wait; do not repeat the operation.',
    '元の印刷ジョブを確認しています。排紙口を確認してお待ちください。操作を繰り返さないでください。',
  ],
  'print.recovering': [
    '列印資料已送出，正在確認印表機狀態，請稍候。',
    'Documents sent. Checking printer readiness; please wait.',
    '印刷データを送信しました。プリンターの状態を確認しています。しばらくお待ちください。',
  ],
  'print.settingsOpen': [
    '列印設定中，請完成並關閉印表機設定視窗。',
    'Printer setup is open. Please finish and close the settings window.',
    'プリンター設定中です。設定を完了して画面を閉じてください。',
  ],
  'print.none': [
    '本次未選擇紙本票券或單據。',
    'No paper documents selected.',
    '紙のチケット・明細は選択されていません。',
  ],
};
